import {
  Box,
  Text,
  Center,
  Image,
  ListItem,
  UnorderedList,
  Link,
} from "@chakra-ui/react";
import worldImage from "../images/worldImage.png";
import { Link as RouterLink } from "react-router-dom";

export default function Collaborate(props) {
  return (
    <div {...props} style={{ paddingTop: "100px" }}>
      <Box
        width={{ base: "90%", md: "77%", lg: "77%" }}
        ml='auto'
        mr='auto'
        background='rgba(31, 159, 181, 0.3)'
        borderRadius={3}
        letterSpacing='tight'
      >
        <Center>
          <Text
            color='white'
            fontSize={{ base: "2xl", md: "3xl", lg: "4xl" }}
            fontWeight={700}
            mt={5}
          >
            Collaborate With Us
          </Text>
        </Center>
        <Box
          display='flex'
          justifyContent='center'
          alignItems='center'
          flexDir={{ base: "column", md: "column", lg: "row" }}
        >
          <Box
            display='flex'
            alignItems='center'
            pl='10px'
            pr='10px'
            pb={5}
            flexShrink='0'
            width={{ base: "90%", md: "90%", lg: "61%" }}
          >
            <Image
              src={worldImage}
              alt='an image of the world map'
              width='100%'
            />
          </Box>
          <Box
            display='flex'
            alignItems='column'
            flexDir='column'
            pl='10px'
            pr='10px'
          >
            <Text color='white' fontSize='16px' textAlign='justify'>
              All users(including guests) can benefit from our features,which
              includes immediate calculation of the POST score, alongside a
              recommendation for the most suitable procedure! However, please
              note that all images will be utilized to further improve our
              algorithm's accuracy.
            </Text>
            <Text color='white' fontSize='16px' textAlign='justify'>
              Moreover, if you choose to contribute at least 250 images, you can
              access exclusive collaborator-only benefits. These include:
            </Text>
            <UnorderedList color='white' fontSize='16px'>
              <ListItem>
                Lifetime access to all available services on hypospadias-ai
              </ListItem>
              <ListItem>
                Co-author status on one of our next scientific publications.
              </ListItem>
            </UnorderedList>
            <Text color='white' fontSize='16px' textAlign='justify'>
              Please do registration{" "}
              <Link to='/collab-registration' color='#528aeb' as={RouterLink}>
                here
              </Link>{" "}
              to collaborate with us.
            </Text>
          </Box>
        </Box>
      </Box>
    </div>
  );
}
